import _ from "lodash";
import { IMPORT_OPTION_KEYS } from "./constants";
import {
  SHEET_TYPES,
  BULK_UPLOAD_MODAL_TYPES,
} from "../../AcademicRecordsModal/modules/BulkUploadConstants";

const MULTIPLE_KEYS = [
  IMPORT_OPTION_KEYS.RATINGS_MULTIPLE,
  IMPORT_OPTION_KEYS.BASIC_DETAILS_MULTIPLE,
];

const RATINGS_KEYS = [
  IMPORT_OPTION_KEYS.RATINGS_SINGLE,
  IMPORT_OPTION_KEYS.RATINGS_MULTIPLE,
];

export const getImportOptionClickParams = ({
  key,
  sidebarStudentIds,
  studentId,
  studentName,
}) => {
  const isMultiple = _.includes(MULTIPLE_KEYS, key);
  const isRatings = _.includes(RATINGS_KEYS, key);

  const sheetType = isRatings ? SHEET_TYPES.RATINGS : SHEET_TYPES.BASIC_DETAILS;

  return {
    modalType: BULK_UPLOAD_MODAL_TYPES.BULK_UPLOAD_IMPORT,
    params: {
      sheetType,
      studentIds: isMultiple ? sidebarStudentIds : [studentId],
      studentName: isMultiple ? null : studentName,
    },
  };
};
